import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'inner-shadow-bottom',
  'IconInnerShadowBottom',
  [
    [
      'path',
      {
        d: 'M18.364 18.364a9 9 0 1 0 -12.728 -12.728a9 9 0 0 0 12.728 12.728z',
        key: 'svg-0',
      },
    ],
    ['path', { d: 'M7.757 16.243a6 6 0 0 0 8.486 0', key: 'svg-1' }],
  ],
);
